export default "__VITE_ASSET__T2JB0Whk__"